<style lang="scss" scoped>
.name-mobile-input {
  width: 300px;
  .el-input {
    width: 110px;
  }
}
.export_label {
  width: 100px;
  margin-top: 20px;
  display: inline-block;
}
.commission-detail-top {
  margin-bottom: 20px;
  .detail-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 80px;
        height: 80px;
        margin-right: 20px;
      }
      .info {
        height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .user-info {
          font-size: 12px;
          .name {
            font-size: 18px;
            color: #606266;
            margin-right: 20px;
          }
          .code {
            margin-right: 20px;
          }
        }
        .store-info {
          color: #606266;
          font-size: 12px;
          .store-name {
            margin-right: 20px;
          }
        }
      }
    }
  }
}
.all-count {
  display: flex;
  .list {
    margin-right: 40px;
    .title {
      color: #9c9fa6;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .price {
      font-size: 18px;
      color: #606266;
      font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC';
    }
  }
}
</style>
<template>
  <!-- 业绩统计 -->
  <div>
    <el-card
      class="commission-detail-top"
      shadow="never"
    >
      <div class="detail-top">
        <div class="left">
          <img
            v-if="customerInfo && customerInfo.avatar"
            :src="customerInfo.avatar"
            alt=""
            width="100%"
          >
          <div
            v-if="customerInfo"
            class="info"
          >
            <div class="user-info">
              <span class="name">{{ customerInfo.salesperson_name }}</span>
              <span class="code">工号：{{ customerInfo.employee_number }}</span>
              <span>类型：{{ customerInfo.employee_status === 1 ? '员工' : '编外' }}</span>
            </div>
            <div class="store-info">
              <span class="store-name">所属门店：{{ customerInfo.store_name }}</span>
              <span>门店编号：{{ customerInfo.store_bn }}</span>
            </div>
          </div>
        </div>
        <div class="right">
          <el-date-picker
            v-model="month"
            type="month"
            placeholder="选择月"
            value-format="yyyy-MM"
            :picker-options="pickerOptions"
            @change="monthChange"
          />
          <div style="margin-top: '10px'">
            <el-button
              type="text"
              @click="seeRules"
            >
              查看当月提成计算规则
            </el-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-card shadow="never">
      <div class="all-count">
        <div
          v-for="(item, index) in totalList"
          :key="index"
          class="list"
        >
          <div class="title">
            {{ item }}
          </div>
          <div class="price">
            {{ customerInfo[index] / 100 }}
          </div>
        </div>
      </div>
    </el-card>

    <el-card shadow="never">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="已确认"
          name="2"
        />
        <el-tab-pane
          label="未确认"
          name="1"
        />
        <el-tab-pane
          label="上月提成订单退款扣减"
          name="3"
        />
        <SpFinder
          id="1"
          ref="finder"
          class="customerNumber"
          title="客户UV报表"
          :no-selection="true"
          :url="{
            data: finderConfig.requestUrl + $route.params.id + '?order_status=' + activeName
          }"
          :show-tool-bar="false"
          :setting="finderConfig.setting"
          :hooks="{
            beforeSearch: beforeSearch
          }"
          :search="finderConfig.search"
          :columns="finderConfig.columns"
          :actions="finderConfig.actions"
          @reset="onFinderReset"
        />
      </el-tabs>
    </el-card>

    <!-- 导出报表对话框 -->
    <SpExportList
      v-model="exportDialogVisible"
      :show-store-select="true"
      :files-type="9"
      export-date="month"
      is-date-single
      include-current-date
    />
  </div>
</template>

<script>
import initFinderConfig from './comps/detailFinder'
import dayjs from 'dayjs'
export default {
  data () {
    const lastMonth = new Date().setMonth(new Date().getMonth() - 1)
    const config = initFinderConfig(this)
    const totalList = {
      'performance': '当月业绩',
      'abnormal_commisson': '上月提成订单退款扣减',
      'unconfirmed_commisson': '当月未确认提成(元)',
      'confirmed_commisson': '当月确认提成(元)'
    }
    return {
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > lastMonth
        }
      },
      finderConfig: config, // finder配置
      params: {},
      searchQuery: {},
      /**
       * 导出数据
       */
      exportDialogVisible: false,
      customerInfo: {},
      activeName: '2',
      totalList,
      lastMonth,
      month: dayjs(lastMonth).format('YYYY-MM')
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    let params = this.$route.params
    this.getCommissionDetail(params.id)
  },
  methods: {
    async getCommissionDetail (id) {
      const data = await this.$api.customerConversion.getCommissionDetail(id, {
        month: this.month,
        salesperson_id: id
      })
      if (data) {
        this.customerInfo = data
      }
    },
    beforeSearch (params) {
      params['month'] = this.month || null
      params['employee_number'] = this.$route.params.id
      console.log('beforeSearch:', params)
      return params
    },
    // 搜索重置
    onFinderReset () {
      this.month = dayjs(this.lastMonth).format('YYYY-MM')
      this.params = {}
    },
    handleClick (tab) {
      this.activeName = tab.name
      this.$refs.finder.refresh()
    },

    monthChange (val) {
      this.month = val
      let params = this.$route.params
      this.getCommissionDetail(params.id)
    },

    seeRules () {
      this.$rulesDiaolog({
        month: this.month
      })
    }
  }
}
</script>
